var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form",
        {
          ref: "form",
          attrs: {
            form: _vm.form,
            "label-col": { span: 12 },
            "wrapper-col": { span: 12 },
          },
        },
        [
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "活动类型名称" } },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.typeName,
                          callback: function ($$v) {
                            _vm.typeName = $$v
                          },
                          expression: "typeName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 20 } },
                [
                  _vm.showDesc
                    ? _c(
                        "a-form-item",
                        { attrs: { label: "活动类型描述" } },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.typeDesc,
                              callback: function ($$v) {
                                _vm.typeDesc = $$v
                              },
                              expression: "typeDesc",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c(
            "a-button",
            {
              on: {
                click: function ($event) {
                  return _vm.endEdit("cancelled")
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }